<template>
<div id="app" :class="appClass">
  <router-view />
</div>
</template>

<script>
import { Common } from './Common.js'
export default {
  mixins:[Common],
  data() {
    return {
      appClass: '',
    }
  },
  mounted : function(){
    this.appClass = this.getAppDivClass(location.hostname)
  }
}
/*
  methods : {
    createMetaTag : function() {
      document.title = 'CancerWith'
    }
  },
  mounted : function(){
    this.createMetaTag()
  },
  watch: {
    '$route' () {
      this.createMetaTag()
    }
  }
*/
</script>